export const SET_STAGE = 'SET_STAGE';
export const SET_QUALITY_CONTROL_QUESTION = 'SET_QUALITY_CONTROL_QUESTION';
export const UPDATE_QUALITY_CONTROL_QUESTION = 'UPDATE_QUALITY_CONTROL_QUESTION';
export const REMOVE_QUALITY_CONTROL_QUESTION = 'REMOVE_QUALITY_CONTROL_QUESTION';

export function setStage(stage) {
  return {
    type: SET_STAGE,
    stage,
  };
}

export function setQualityControlQuestion(question) {
  return {
    type: SET_QUALITY_CONTROL_QUESTION,
    question,
  };
}

export function updateQualityControlQuestion(question) {
  return {
    type: UPDATE_QUALITY_CONTROL_QUESTION,
    question,
  };
}

export function removeQualityControlQuestion(question) {
  return {
    type: REMOVE_QUALITY_CONTROL_QUESTION,
    question,
  };
}



// WEBPACK FOOTER //
// ./src/actions/stages.js